export function waitFor(predicate: () => boolean, timeout: number) {
  return new Promise((resolve, reject) => {
    let timer: ReturnType<typeof setTimeout> | undefined;

    const check = () => {
      if (!predicate()) return;
      clearInterval(interval);
      if (timer) clearTimeout(timer);
      resolve(true);
    };

    const interval = setInterval(check, 100);
    check();

    timer = setTimeout(() => {
      clearInterval(interval);
      reject(new Error('Timeout expired'));
    }, timeout);
  });
}
